/*
 * @Descripttion: 
 * @version: 
 * @Author: wangz
 * @Date: 2019-11-21 14:58:04
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-20 09:15:23
 */
//追加新的sgiConfig的配置信息
// let ip = "https://www.egssoft.com.cn";
let ip = "http://100.1.1.26";
let zuul = ip + ":8088";
let sgiConfigDefault = {
	currentAP: 'rtsd',
	pf: zuul + "/pf",
	// pf: "https://www.egssoft.com.cn:8895/pf",
	service: zuul,

	fileAction: zuul + "/fileserver/uploadFile",//文件服务器
	fileActionB64: zuul + "/fileserver/uploadFileB64",
	bussType: "rtsd",//项目路径

	popMessageMaxCount: 1,//popMessage方法弹出消息最大数量
	prmRelease: false,

	// 默认日志级别降低，方便测试；各项目配置自己合适的日志级别
	logger: {
		level: -1,
		stack: true
	},

	prmEditor: false
};

// 初始化
if (!window.sgiConfig) window.sgiConfig = {};
// 添加方法
Object.assign(window.sgiConfig, sgiConfigDefault);
// 导出
export default window.sgiConfig;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiConfig/sgiConfig.js